import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import { css } from '@mui/material/styles';
import { useIntl } from '@doxyme/locale';
import { modalClasses } from '../modal.classes';
import { useModalFooterStyles } from './modalFooter.styles';
import { Button } from '@doxyme/ui-foundation/components/button';
import { Icon } from '@doxyme/icons';
import { Tooltip } from '@doxyme/ui-foundation/components/tooltip';
import { Caption } from '@doxyme/ui-foundation/typography';
const ButtonWithTooltip = ({ button, children })=>{
    const defaultStyles = useModalFooterStyles({
        layout: 'default'
    });
    if (button === undefined) return undefined;
    if (button.tooltipText === undefined) return children;
    if (button.isDisabled) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: button.tooltipText,
            children: /*#__PURE__*/ _jsx(Box, {
                css: defaultStyles.buttonContainer,
                children: children
            })
        });
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: button.tooltipText,
        children: children
    });
};
/**
 * Renders a fixed bottom Footer for the Modal. Optionally pass in `submitButton` when building a form. Has to be placed within `<ModalContent>`
 */ export const ModalFooter = ({ onBack, submitButton, secondaryButton, styles, layout = 'default', caption })=>{
    const { formatMessage } = useIntl();
    const defaultStyles = useModalFooterStyles({
        layout
    });
    return /*#__PURE__*/ _jsxs(Box, {
        css: css(defaultStyles.container, modalClasses.footer),
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                css: defaultStyles.buttonContainer,
                children: [
                    onBack && /*#__PURE__*/ _jsx(Tooltip, {
                        title: formatMessage({
                            id: 'back'
                        }),
                        offset: -4,
                        children: /*#__PURE__*/ _jsx("span", {
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "outline",
                                className: modalClasses.backButton,
                                onClick: onBack,
                                width: 40,
                                css: defaultStyles.backButton,
                                "aria-label": formatMessage({
                                    id: 'back'
                                }),
                                children: /*#__PURE__*/ _jsx(Icon.ArrowLeft, {
                                    type: "filled",
                                    className: modalClasses.backIcon,
                                    style: styles?.backIcon,
                                    size: "small",
                                    "aria-hidden": true
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        css: defaultStyles.buttons,
                        children: layout === 'equal-buttons' ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(ButtonWithTooltip, {
                                    button: submitButton,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        ...submitButton,
                                        status: submitButton?.status,
                                        type: submitButton?.type ?? 'primary'
                                    })
                                }),
                                /*#__PURE__*/ _jsx(ButtonWithTooltip, {
                                    button: secondaryButton,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        ...secondaryButton,
                                        type: secondaryButton?.type ?? 'secondary'
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(ButtonWithTooltip, {
                                    button: secondaryButton,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        ...secondaryButton,
                                        type: secondaryButton?.type ?? 'secondary'
                                    })
                                }),
                                /*#__PURE__*/ _jsx(ButtonWithTooltip, {
                                    button: submitButton,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        ...submitButton,
                                        status: submitButton?.status,
                                        type: submitButton?.type ?? 'primary'
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            caption && /*#__PURE__*/ _jsx(Caption, {
                css: defaultStyles.caption,
                children: caption
            })
        ]
    });
};

//# sourceMappingURL=modalFooter.js.map